module.exports = __webpack_public_path__ + "static/assets/0f83313fc24139957bd5756a6734b491.png";